import { enUS, es, pt, ca, eu, fr, lv } from 'date-fns/locale'
import { useTranslation } from 'react-i18next'
import * as muiLocales from '@mui/material/locale'
import { localeCodeOf } from '../../utilities/customLanguage'

const useSmartTranslation = () => {
  const { t: t_, i18n } = useTranslation()
  return { t_, i18n }
}

const useLocalizationProviderAdapterLocale = () => {
  const { i18n } = useTranslation()

  switch (localeCodeOf(i18n.language)) {
    case 'es':
      return es
    case 'eus':
      return eu
    case 'pt':
      return pt
    case 'ca':
      return ca
    case 'fr':
      return fr
    case 'lv':
      return lv
    default:
      return enUS
  }
}

export default useSmartTranslation
/**
 * P17: MUI's own texts (the "Open"/"Close" of a select, the pagination buttons, "No options"…) in the user's language.
 * Basque and Latvian have no MUI translation: they keep MUI's English.
 */
const useMuiLocale = () => {
  const { i18n } = useTranslation()

  switch (localeCodeOf(i18n.language)) {
    case 'es':
      return muiLocales.esES
    case 'pt':
      return muiLocales.ptPT
    case 'ca':
      return muiLocales.caES
    case 'fr':
      return muiLocales.frFR
    case 'de':
      return muiLocales.deDE
    default:
      return muiLocales.enUS
  }
}

export { useLocalizationProviderAdapterLocale, useMuiLocale }
